import { FormHelperText } from "@mui/material";

export interface PricingTypeErrorProps {
	text: string;
}

export default function PricingTypeError(props: PricingTypeErrorProps) {
	const { text } = props;

	return (
		<FormHelperText
			sx={{ fontSize: "16px", marginBottom: "12px" }}
			error={true}
		>
			{text}
		</FormHelperText>
	);
}
